import { HOWXM_NAMESPACE } from 'scripts/constants'

type keyType = 'publishedEntryId' | 'urlPublishedFormToken' | 'publishedFormToken' | 'formSetting'

export default function getStorageKey(key: keyType, token: string) {
  return `${HOWXM_NAMESPACE}_${key}_${token}`
}
